import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import customModal from "../customModal/customModal.vue";
import discrepancyModal from "../SDV_Discrepancymodal/SDV_Discrepancymodal.vue";
import ListSdvQueryModal from "../ListSdvQueryModal/ListSdvQueryModal.vue";

export default {
  name: 'sdvVerificationModal',
  props: {
    // Only the ID is passed in now. The modal owns fetching/refreshing
    // its own record so the list can update dynamically after any action.
    sdvRecordId: {
      type: String,
      default: '',
    },
    modalType: {
      type: String,
      default: 'doSDV',
    },
    fromTab: {
      type: String,
      default: 'dataSignal',
    },
  },
  emits: ['closeModal', 'sdvUpdated'],
  components: {
    customModal,
    Multiselect,
    discrepancyModal,
    ListSdvQueryModal,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      headerValues: {},
      studyId: "",
      sdvRecord: {},
      sdvDataRef: [],
      siteList: [],
      pageSize: 50,
      selectedSDV: {},
      sdvPayload: {},
      dataIndex: [],
      disabledIndex: [],
      selectedDataRefIDs: [],
      selectAllChecked: false,
      showDiscrepancyModal: false,
      showQueryModal: false,
      selectedId: "",
      selectedFieldName: "",
    };
  },
  async mounted() {
    this.studyId = store.getters.getStudyIs;
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    await this.fetchSDVRecord();
    this.getSites();
  },
  methods: {
    closeSDVModal() {
      this.$emit('closeModal');
    },

    // Fetches the record fresh from the server, using only the ID passed
    // in via props. Called on mount and again after every verify/discrepancy
    // action, so the table always reflects the latest server state.
    async fetchSDVRecord() {
      try {
        const response = await axios.get(
         `${this.baseurl}/forms/managesdv/getsdvrecordbyid?id=${this.sdvRecordId}&studyId=${this.studyId}`,
          this.headerValues
        );
        this.sdvRecord = response.data;
        this.mapSdvRecordToDataRef();
        this.mapIndex();
        // Selections don't carry over across a refresh since row state may have changed.
        this.selectedDataRefIDs = [];
        this.selectAllChecked = false;
      }
      catch (error) {
        console.error("Error fetching SDV record:", error);
      }
    },

    // Builds sdvDataRef from the freshly-fetched sdvRecord.
    mapSdvRecordToDataRef() {
      if (!this.sdvRecord || !Array.isArray(this.sdvRecord.sdvItems)) {
        this.sdvDataRef = [];
        return;
      }

      this.sdvDataRef = this.sdvRecord.sdvItems.map(item => ({
        DataRefID: item.itemId,
        _id: item.itemId,
        ItemId: item.itemId,
        SiteId: this.sdvRecord.siteId,
        SiteCode: this.sdvRecord.siteCode,
        SubjectId: this.sdvRecord.subjectId,
        SubjectNo: this.sdvRecord.subjectNo,
        VisitFormName: this.sdvRecord.visitFormName,
        FormName: this.sdvRecord.formName,
        FieldName: item.fieldName,
        FieldLabel:item.fieldLabel,
        FieldValue: item.capturedValue,
        Outcome: item.outcome,
        // Maps new enum values to the display values the template checks against.
        SDVStatus:
          item.status === 'Verified' ? 'Completed'
          : item.status === 'Discrepancy' ? 'Discrepant'
          : 'Pending',
        SDVVerificationComments: item.comments,
        DiscrepancyReason: item.discrepancy ? item.discrepancy.reason : '',
        SDVVerfiedDate: item.verifiedAt,
        SDVVerifiedUserID: item.verifiedByUserId,
        SDVVerifiedEmail: item.verifiedByEmail,
      }));
    },

    async getSites() {
      try {
        const response = await axios.get(`${this.baseurl}/management/site/getallsitesbyuser?studyId=${this.studyId}&getAll=false`, this.headerValues);
        this.siteList = response.data;
      }
      catch (error) {
        console.error("Error fetching sites:", error);
      }
    },

    async mapIndex() {
      this.dataIndex = [];
      this.disabledIndex = [];
      this.sdvDataRef.forEach((data, index) => {
        if (data.SDVStatus == 'Completed' || data.SDVStatus === 'Discrepant') {
          this.dataIndex.push(true);
          this.disabledIndex.push(index);
        }
        else {
          this.dataIndex.push(false);
        }
      });
    },

    // Calls the reviewformsdvitem endpoint using the ReviewSDVCommand shape.
    async verifySourceData() {
      try {
        const result = await axios.put(`${this.baseurl}/forms/managesdv/reviewformsdvitem`, this.sdvPayload, this.headerValues);
        alert(this.$t('navigations.sdv completed successfully'));
        console.log("verify source data result", result);
      }
      catch (error) {
        console.error("Error in verify source data:", error);
      }
    },

    async verifyRow(row, action) {
      await this.mapRow(row, action);
      await this.verifySourceData();
      await this.fetchSDVRecord();
      this.$emit('sdvUpdated', this.sdvRecordId);
    },

    async discrepantRow(row) {
      await this.mapRow(row, 'Discrepancy');
      this.showDiscrepancyModal = true;
    },

    async verifySelected() {
      if (!this.selectedDataRefIDs.length) {
        alert(this.$t('navigations.please select at least one item'));
        return;
      }
      if (confirm(this.$t(`navigations.are you sure you want to verify all selected data?`))) {
        await this.mapMultipleRows('Verified');
        await this.verifySourceData();
        await this.fetchSDVRecord();
        this.$emit('sdvUpdated', this.sdvRecordId);
      }
    },

    async discrepantSelected() {
      if (!this.selectedDataRefIDs.length) {
        alert(this.$t('navigations.please select at least one item'));
        return;
      }
      if (confirm(this.$t(`navigations.are you sure you want to mark as discrepant for all selected data?`))) {
        await this.mapMultipleRows('Discrepancy');
        this.showDiscrepancyModal = true;
      }
    },

    // Builds a single-item ReviewSDVCommand payload.
    async mapRow(row, action) {
      this.sdvPayload = {
        recordId: this.sdvRecordId,
        action: action.toLowerCase(),
        items: [
          {
            sdvItemId: String(row.DataRefID),
            comments: "",
            actualValue: this.arrayToCommaString(row.FieldValue),
          },
        ],
      };
    },

    async selectRow(row, index) {
      if (this.dataIndex[index] == false) {
        this.selectedDataRefIDs.push(row.DataRefID);
      }
      else {
        const idx = this.selectedDataRefIDs.indexOf(row.DataRefID);
        if (idx !== -1) {
          this.selectedDataRefIDs.splice(idx, 1);
        }
      }
    },

    // Builds a multi-item (bulk) ReviewSDVCommand payload.
    async mapMultipleRows(action) {
      this.sdvPayload = {
        recordId: this.sdvRecordId,
        action: action.toLowerCase(),
        items: this.selectedDataRefIDs.map(id => {
          const row = this.sdvDataRef.find(r => r.DataRefID === id);
          return {
            sdvItemId: String(id),
            comments: "",
            actualValue: row ? this.arrayToCommaString(row.FieldValue) : "",
          };
        }),
      };
    },

    async SelectAll() {
      this.selectedDataRefIDs = [];
      if (this.selectAllChecked === false) {
        this.dataIndex.forEach((_, index) => {
          if (!this.disabledIndex.includes(index)) {
            this.dataIndex[index] = false;
          }
        });
      } else {
        this.dataIndex.forEach((_, index) => {
          if (!this.disabledIndex.includes(index)) {
            this.dataIndex[index] = true;
          }
        });
        this.sdvDataRef.forEach((ref, index) => {
          if (!this.disabledIndex.includes(index)) {
            this.selectedDataRefIDs.push(ref.DataRefID);
          }
        });
      }
    },

    // Refreshes from the server after a discrepancy is submitted, instead
    // of re-mapping a stale local object.
    async closeDiscrepancy() {
      await this.fetchSDVRecord();
      this.$emit('sdvUpdated', this.sdvRecordId);
      this.showDiscrepancyModal = false;
    },

    arrayToCommaString(arr) {
      if (!Array.isArray(arr)) return '';
      return arr.join(', ');
    },

    Openquerypopup(row) {
      this.showQueryModal = true;
      this.selectedId = row._id;
      this.selectedFieldName = row.FieldName;
    },

    async closeQueryModal() {
      this.showQueryModal = false;
    },
  },
  computed: {
    hasPendingItems() {
      try {
        return Array.isArray(this.sdvDataRef) && this.sdvDataRef.some(r => r.SDVStatus === 'Pending');
      } catch (e) {
        return false;
      }
    }
  },
};
